(function() {
    'use strict';

    angular
        .module('setupApp')
        .controller('ReasonCancelDialogController', ReasonCancelDialogController);

    ReasonCancelDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'DataUtils', 'entity', 'ReasonCancel'];

    function ReasonCancelDialogController ($timeout, $scope, $stateParams, $uibModalInstance, DataUtils, entity, ReasonCancel) {
        var vm = this;

        vm.reasoncancel = entity;
        vm.clear = clear;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;
        vm.save = save;
        vm.checkcreat = false;
        if (vm.reasoncancel.paymentCancelId != null || vm.reasoncancel.paymentCancelId != undefined) {
        	 vm.checkcreat = true;
        	 vm.reasoncancel.isExit= true;
        }else{
        	vm.reasoncancel.isExit= false;
        }
        if(vm.reasoncancel.status == '1'){
        	vm.reasoncancel.statusCancel = true;
        }else{
        	vm.reasoncancel.statusCancel = false;
        }
        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if(vm.reasoncancel.statusCancel == true){
        		vm.reasoncancel.status = '1';
        	}else{
        		vm.reasoncancel.status = '0';
        	}
            if (vm.reasoncancel.isExit == true) {
            	ReasonCancel.update(vm.reasoncancel, onSaveSuccess, onSaveError);
            } else {
            	ReasonCancel.save(vm.reasoncancel, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('setupApp:reasonCancelUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }



    }
})();
